"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.ai.title': '咨询AI助手',
    'socialMediaPlan.ai.desc': 'AI助手分析您的帖子库。',
    'socialMediaPlan.ai.preset.topics': '最佳话题',
    'socialMediaPlan.ai.preset.plan': '下周内容计划',
    'socialMediaPlan.ai.preset.timing': '最佳发布时间',
    'socialMediaPlan.ai.preset.summary': '月度总结',
    'socialMediaPlan.ai.placeholder': '请输入问题...',
    'socialMediaPlan.ai.ask': '咨询AI',
    'socialMediaPlan.ai.error': 'AI助手错误。',
};
